/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addLocaleData, IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef } from 'react';

import * as LocalizationActions from '../actions/localization';
import output from '../utilities/output';

export function Intl(props) {
  const previousProps = useRef(props);
  const loadLocaleData = useCallback(() => {
    const countryCode = props.locale.split('-')[0];
    let locale;
    if (countryCode === 'qat') {
      locale = require('./qat'); // eslint-disable-line global-require, import/no-dynamic-require
    } else {
      locale = require(`react-intl/locale-data/${countryCode}`); // eslint-disable-line global-require, import/no-dynamic-require
    }
    addLocaleData([...locale]);
  }, [props.locale]);
  useEffect(() => {
    loadLocaleData();
    props.actions.getLocalizations({ locale: props.locale });
  }, []);
  useEffect(() => {
    const prevProps = previousProps.current;
    if (prevProps.locale !== props.locale) {
      prevProps.actions.getLocalizations({ locale: props.locale });
    }
    previousProps.current = props;
  }, [props]);
  output.log('Current locale:', props.locale);
  return (
    <IntlProvider locale={props.locale} messages={props.localizations}>
      {props.children}
    </IntlProvider>
  );
}

Intl.displayName = 'Intl Config';

Intl.propTypes = {
  actions: PropTypes.shape({
    getLocalizations: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node,
  locale: PropTypes.string,
  localizations: PropTypes.object,
};

Intl.defaultProps = {
  locale: 'en-us',
};

function mapStateToProps(state) {
  return {
    locale: state.localization.locale,
    localizations: state.localization.localizations,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(LocalizationActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Intl);
